import styled, { css } from 'styled-components';
import { Heading } from '@higo/ui';
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as HigoLogo } from '@higo/ui/src/assets/icon/logo.svg';

const BlankPageContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const LogoImage = styled('div')(
  ({ theme }) => css`
    width: 9.75rem;
    height: 6rem;
    margin-bottom: 3rem;
    fill: ${theme.palette.primary['500']};
  `,
);

// unify with the current design
const StyledHeading = styled(Heading)`
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 2.1875rem;
`;

export const BlankPage = () => (
  <BlankPageContainer>
    <LogoImage>
      <HigoLogo />
    </LogoImage>
    <StyledHeading level={1}>HIGO</StyledHeading>
  </BlankPageContainer>
);
